import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '/src/components/Home/Home.vue'

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        component: Home,
        meta: { title: '义乌市仓堡网络科技有限公司' }
    }
];
const router = new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title || '义乌市仓堡网络科技有限公司';
    next();
})
export default router